import Helmet from "react-helmet";

import { Outlet } from "react-router-dom";

import { getPageTitle } from "@utils";

import { PortfoliosTable } from "./PortfoliosTable";

export default function Portfolios() {
  return (
    <>
      <Helmet>
        <title>{getPageTitle("Portfolios")}</title>
      </Helmet>
      <PortfoliosTable />
      <Outlet />
    </>
  );
}
